import { AuthScreen } from "@/pages/Login";

export default function Register() {
  return (
    <AuthScreen
      title="Get started"
      tagline="Create your ClosetFlip account"
      cta="Continue with Google"
    />
  );
}
